import { BackgroundMusicOptions, evaluateBackgroundMusicOptions, VariableDictionary } from '@videosmart/player-template';
import { createSelector } from 'reselect';

import { RootState } from '../models';

export const selectEvaluatedBackgroundMusic = createSelector(
	(state: RootState) => (state.data.isLoaded && state.data.variables) || undefined,
	(state: RootState) => (state.data.isLoaded && state.data.template && state.data.template.backgroundMusicOptions) || undefined,
	(variables: VariableDictionary | undefined, backgroundMusicOptions: BackgroundMusicOptions | undefined) => {
		if (variables && backgroundMusicOptions) {
			return evaluateBackgroundMusicOptions(backgroundMusicOptions, variables);
		}
	}
);
